var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.6C0 1.61177 1.61178 0 3.6 0H20.4C22.3882 0 24 1.61178 24 3.6V20.4C24 22.3882 22.3882 24 20.4 24H3.6C1.61177 24 0 22.3882 0 20.4V3.6Z",
    fill: "#03AFCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61073 8.74845V6.95286H8.96527V17.1H6.9609V8.74845H5.61073Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8904 11.8942C10.8904 10.2888 11.178 9.03147 11.7534 8.12208C12.338 7.21269 13.303 6.75799 14.6486 6.75799C15.9941 6.75799 16.9545 7.21269 17.5299 8.12208C18.1145 9.03147 18.4068 10.2888 18.4068 11.8942C18.4068 13.5088 18.1145 14.7755 17.5299 15.6942C16.9545 16.6128 15.9941 17.0722 14.6486 17.0722C13.303 17.0722 12.338 16.6128 11.7534 15.6942C11.178 14.7755 10.8904 13.5088 10.8904 11.8942ZM16.4859 11.8942C16.4859 11.2075 16.4395 10.6322 16.3467 10.1682C16.2632 9.69496 16.0869 9.30986 15.8178 9.01291C15.558 8.71597 15.1682 8.5675 14.6486 8.5675C14.1289 8.5675 13.7345 8.71597 13.4654 9.01291C13.2056 9.30986 13.0293 9.69496 12.9365 10.1682C12.853 10.6322 12.8112 11.2075 12.8112 11.8942C12.8112 12.5994 12.853 13.1933 12.9365 13.6759C13.02 14.1491 13.1963 14.5342 13.4654 14.8312C13.7345 15.1188 14.1289 15.2627 14.6486 15.2627C15.1682 15.2627 15.5626 15.1188 15.8317 14.8312C16.1008 14.5342 16.2771 14.1491 16.3606 13.6759C16.4442 13.1933 16.4859 12.5994 16.4859 11.8942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge10);
export default __webpack_public_path__ + "static/media/age10.910642cb.svg";
export { ForwardRef as ReactComponent };